import React, { useEffect, useState } from "react";
import { Alert, CircularProgress, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { api } from "../../../services/api";
import useEventoStore from "../../../stores/useEventoStore";
import EditorPublicacion from "../../../components/publicacion/EditorPublicacion";
import GestionFaqs from "../../../components/faqs/GestionFaqs";
import BannerPreview from "../../../components/evento/BannerPreview";
import { fromPublicacion } from "../../../domain/publicacion/payload";

/* Paso "Publicar" del alta. La publicación es opcional y se guarda con su
 * propio botón, como el paso Información: si se recarga o se vuelve al paso,
 * sigue ahí. "Finalizar evento" sólo confirma el evento. */
export const PublicarEvento = ({ eventId, isPublic }) => {
  const [evento, setEvento] = useState(null);
  const [valores, setValores] = useState(undefined); // undefined: cargando
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelado = false;
    const cargar = async () => {
      try {
        const [data, pubs] = await Promise.all([
          useEventoStore.getState().fetchEvento(eventId),
          api.publicaciones.getAll(eventId, "", 1, 1),
        ]);
        if (cancelado) return;
        setEvento(data?.evento ?? null);
        const existente = pubs.status === "success" ? pubs.data?.publicaciones?.[0] : null;
        setValores(existente ? fromPublicacion(existente) : null);
      } catch (err) {
        if (!cancelado) setError("No se pudo cargar la publicación.");
      }
    };
    cargar();
    return () => { cancelado = true; };
  }, [eventId]);

  const guardar = async (payload) => {
    try {
      const response = payload.id
        ? await api.publicaciones.updatePublicacion(payload)
        : await api.publicaciones.createPublicacion(payload);
      if (response.status !== "success") {
        toast.error(response.message || "No se pudo guardar la publicación.");
        return;
      }
      const guardada = response.data?.publicacion ?? response.data;
      if (guardada?.id) setValores(fromPublicacion(guardada));
      toast.success("Publicación guardada.");
    } catch (err) {
      toast.error("No se pudo conectar con el servidor.");
    }
  };

  if (error) return <Alert severity="error" sx={{ m: 3 }}>{error}</Alert>;

  return (
    <div className="d-flex justify-content-center px-2 mt-4">
      <div style={{ maxWidth: "700px", width: "100%" }}>
        <Typography variant="h6" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
          Vista previa de tu publicación
        </Typography>
        <p className="mb-0">
          Así se va a ver tu evento en el inicio. Es opcional: si no la cargás, podés finalizar igual y crearla después.
        </p>

        {valores === undefined ? (
          <div className="d-flex justify-content-center p-5"><CircularProgress /></div>
        ) : (
          <EditorPublicacion
            evento={evento}
            eventoId={eventId}
            valoresIniciales={valores}
            esNueva={!valores?.id}
            onSubmit={guardar}
            textoSubmit={valores?.id ? "Guardar cambios" : "Guardar publicación"}
          />
        )}

        <GestionFaqs eventoId={eventId} compacto />

        {isPublic && eventId && <BannerPreview eventId={eventId} />}
      </div>
    </div>
  );
};
